import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import AutoCarousel from './auto_carousel/AutoCarousel';
import styles from './CampaignPreview.module.sass';
import Button from '../../../../ui_kit/button/Button';
import { userObjectSelector } from '../../../../user/selectors/user';
import { modalsActions } from '../../../../modals/actions';
import MODALS from '../../../../modals/constants/modals';
import { campaignsActions } from '../../../actions';

function campaignPath(slug) {
  return `/campaigns/${slug}/`;
}

class CampaignPreview extends Component {
  componentDidMount() {
    window.lazyLoad.update();
  }

  vote = () => {
    const {
      user, openSignUpModal, campaign: {
        id, is_voted: isVoted, is_winner: isWinner, loading, password,
      }, voteRequest, openCampaignPasswordModal,
    } = this.props;

    if (isVoted || isWinner || loading) { return; }

    if (password && Cookies.get(`campaign_${id}_password`) !== password) {
      window.campaignPasswordSubmittedCallback = () => {
        this.vote();
      };

      Cookies.set(`campaign_${id}_correct_password`, password);

      openCampaignPasswordModal({ campaignId: id });

      return;
    }

    if (!user) {
      Cookies.set('signed_up_from', 'voting');

      openSignUpModal();

      window.userLoggedInCallback = (loggedInUser) => {
        if (loggedInUser.sign_in_count > 1 && loggedInUser.confirmed_at) {
          voteRequest(id, loggedInUser, true);
        } else {
          voteRequest(id, loggedInUser, false);
        }
      };

      return;
    }

    voteRequest(id, user, true);
  };

  buttonText = () => {
    const {
      campaign: {
        is_voted: isVoted, is_winner: isWinner,
        available_for_preorder: availableForPreorder,
        preorders_percent: preordersPercent,
        redirect_to_shop: redirectToShop,
      },
    } = this.props;

    if (isWinner && !availableForPreorder) { return 'CAMPAIGN WINNER'; }

    if (!isVoted && !availableForPreorder) { return 'JOIN WAITLIST NOW'; }

    if (redirectToShop) { return 'ADD TO BAG'; }

    if (availableForPreorder && preordersPercent === 100) { return 'PRE-ORDER AVAILABLE'; }

    if (availableForPreorder) { return 'PRE-ORDER NOW'; }

    return 'THANKS FOR JOINING WAITLIST';
  };

  render() {
    const {
      campaign: {
        background_image: backgroundImage, preview_image: image,
        preview_image_placeholder: imagePlaceholder, title,
        subtitle, innovator_name: innovatorName, innovator_url: innovatorUrl,
        target_votes_number: targetVotesNumber, votes_count: votesCount,
        days_left: daysLeft, friendly_id: friendlyId, loading, sticker_text: stickerText,
        available_for_preorder: availableForPreorder, preorders_percent: preordersPercent,
        estimated_ship_date: estimatedShipDate, carousel_images: carouselImages,
        variants, show_days_left: showDaysLeft,
      }, className,
    } = this.props;

    const votesPercent = Math.min((votesCount / targetVotesNumber) * 100, 100);

    const showEstimatedShipDate = availableForPreorder && preordersPercent === 100
      && estimatedShipDate;

    return (
      <div className={`${styles.campaign} ${className}`}>
        <a href={campaignPath(friendlyId)}>
          { backgroundImage && (
            <div className={styles.images}>
              <div className={styles.background}>
                <img className="lazyload" data-src={backgroundImage} alt={title} />
              </div>
              { stickerText && (
                <div className={styles['sticker-wrapper']}>
                  <div className={styles.sticker}>
                    {stickerText}
                  </div>
                </div>
              )}
              <AutoCarousel
                carouselImages={carouselImages}
                imagePlaceholder={imagePlaceholder}
                campaignImage={image}
                title={title}
              />
            </div>
          )}
          { !backgroundImage && (
            <div className={styles.image}>
              <img className="lazyload blur" src={imagePlaceholder} data-src={image} alt={title} />
            </div>
          )}
        </a>
        <a href={campaignPath(friendlyId)}>
          <div className={styles.title}>
            {title}
          </div>
        </a>
        <div className={styles.description}>
          {subtitle}
        </div>
        <a href={innovatorUrl}>
          <div className={styles.innovator}>
            By
            {' '}
            {innovatorName}
          </div>
        </a>
        { availableForPreorder ? (
          (
            <>
              <div className={styles['progress-bar']}>
                <div className={styles.filled} style={{ width: `${preordersPercent}%` }} />
                <div className={styles.background} />
              </div>
              <div className={styles.stat}>
                <div className={styles.value}>
                  {`${Math.floor(preordersPercent)}%`}
                </div>
                <div className={styles.name}>
                  { preordersPercent === 100 ? 'Minimum Pre-Orders Achieved' : 'Pre-Orders Filled' }
                </div>
              </div>
            </>
          )
        ) : (
          <>
            <div className={styles['progress-bar']}>
              <div className={styles.filled} style={{ width: `${votesPercent}%` }} />
              <div className={styles.background} />
            </div>
            <div className={styles.stat}>
              <div className={styles.value}>
                {`${Math.floor(votesPercent)}%`}
              </div>
              <div className={styles.name}>
                Waitlist Filled
              </div>
            </div>
          </>
        )}
        <div className={styles.stat}>
          { showEstimatedShipDate && (
            <>
              <div className={styles.value}>
                Estimated Ship Date:
              </div>
              <div className={styles.name}>
                {estimatedShipDate}
              </div>
            </>
          )}
          {showDaysLeft && !showEstimatedShipDate && (
            <>
              <div className={styles.value}>
                {daysLeft}
              </div>
              <div className={styles.name}>
                Days Remaining
              </div>
            </>
          )}
        </div>
        { (variants.length > 0 || availableForPreorder)
          ? (
            <Button
              size="small"
              color="blue"
              text={this.buttonText()}
              className={styles.button}
              href={campaignPath(friendlyId)}
            />
          )
          : (
            <Button
              size="small"
              color="blue"
              text={this.buttonText()}
              className={styles.button}
              onClickHandler={this.vote}
              loading={loading}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  openSignUpModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.JOIN_THE_LOUNGE_FOR_VOTING,
  })),
  openCampaignPasswordModal: (params) => dispatch(modalsActions.openModalRequest({
    modal: MODALS.CAMPAIGN_PASSWORD,
    data: params,
  })),
  voteRequest: (campaignId, user, showDefaultVoteDialog) => {
    dispatch(campaignsActions.voteRequest({ campaignId, user, showDefaultVoteDialog }));
  },
});

CampaignPreview.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.number.isRequired,
    background_image: PropTypes.string,
    preview_image: PropTypes.string.isRequired,
    preview_image_placeholder: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    innovator_name: PropTypes.string.isRequired,
    innovator_url: PropTypes.string.isRequired,
    target_votes_number: PropTypes.number.isRequired,
    votes_count: PropTypes.number.isRequired,
    days_left: PropTypes.number.isRequired,
    show_days_left: PropTypes.bool.isRequired,
    friendly_id: PropTypes.string.isRequired,
    is_voted: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    is_winner: PropTypes.bool.isRequired,
    variants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    password: PropTypes.string,
    sticker_text: PropTypes.string,
    available_for_preorder: PropTypes.bool,
    preorders_percent: PropTypes.number,
    estimated_ship_date: PropTypes.string,
    redirect_to_shop: PropTypes.bool.isRequired,
    carousel_images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  user: PropTypes.shape({
    sign_in_count: PropTypes.number,
    confirmed_at: PropTypes.string,
  }),
  openSignUpModal: PropTypes.func.isRequired,
  openCampaignPasswordModal: PropTypes.func.isRequired,
  voteRequest: PropTypes.func.isRequired,
  className: PropTypes.string,
};

CampaignPreview.defaultProps = {
  user: null,
  className: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignPreview);
